<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/saleNumData')">商品销量统计</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='商品名称'>
            <el-input
                  v-model="filters.title"
                  style="width:230px"
                  placeholder="请输入商品名称"
                >
                </el-input>
          </el-form-item>
          <!-- <el-form-item label='按天/月'>
            <el-select
              v-model="filters.dayType"
              clearable
            >
              <el-option
                label="天"
                :value="1"
              ></el-option>
              <el-option
                label="月"
                :value="2"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label='代理等级'>
            <el-select
              v-model="filters.roleType"
              clearable
            >
              <el-option label="联盟店" value="1"></el-option>
                <el-option label="董事" value="4.2"></el-option>
                <el-option label="经销商" value="4.8"></el-option>
                <el-option label="区域总监" value="5.1"></el-option>
                <el-option label="城市加盟商" value="5.2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                :type="filters.dayType && filters.dayType == 2 ? 'month' : 'date' "
                placeholder="选择日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >统计</el-button>

            <el-button
              style="margin-left:10px"
              @click="goDown"
              type="danger"
              size="small"
            >到底部</el-button>

            <el-button
              style="margin-left:10px"
              @click="goTop"
              type="warn"
              size="small"
            >到顶部</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
          请选择好条件后，点击统计
        </div>
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="goodName"
            label="商品名称"
          >
          </el-table-column>

          <el-table-column
            prop="noVipName"
            label="耗材类型"
          >
          </el-table-column>

          <el-table-column
            label="列表图片"
            prop="listPic"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.listPic"
                style="width:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="fakeSaleNum"
            label="虚拟销量"
          >
          </el-table-column>

          <el-table-column
            prop="realSaleNum"
            label="物流发货销量"
          >
          </el-table-column>

          <el-table-column
            prop="realSaleNumI"
            label="自提发货销量"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template>

                <el-button
                  @click="showDetailInfos(scope.row, 2)"
                  type="text"
                  size="small"
                >查看发货订单</el-button>

                <el-button
                  @click="showDetailInfos(scope.row, 1)"
                  type="text"
                  size="small"
                >查看虚拟订单</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>

    <el-dialog
      title="明细"
      :visible.sync="subListVisible"
      width="70%"
    >
      <el-button
        type="primary"
        @click="excelOut1"
      >导出</el-button>
      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="role_type"
          :formatter="formatterRoleType"
          label="代理级别"
        >
        </el-table-column>

        <el-table-column
          prop="username"
          label="代理姓名"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="代理手机号"
        >
        </el-table-column>

        <el-table-column
          prop="create_time"
          label="时间"
        >
        </el-table-column>

        <el-table-column
          prop="num"
          label="数量"
        >
        </el-table-column>

        <el-table-column
          prop="good_name"
          label="商品名称"
        >
        </el-table-column>
        
        <el-table-column
          prop="show_name"
          label="店铺名称"
        >
        </el-table-column>

        <el-table-column prop="show_name" label="店铺地址" width="200">
            <template
              slot-scope="scope"
            >{{scope.row.province}}{{scope.row.city}}{{scope.row.district}}{{scope.row.address_detail}}</template>
          </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page_num"
          :page-count='total_page'
          :page-size="page_size"
          layout="total, prev, pager, next"
          :total="total_num"
        >
        </el-pagination>
      </div>

    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "saleNumData",
  created() {},

  data() {
    return {
      totalMoney: 0,
      searchType:null,
      searchGoodId:null,
      subListVisible: false,
      listLoading: false,
      noVipName: null,
      picList: [],
      filters: {
        roleType:null,
        status: null,
        startTime: null,
        title: null,
        userId: null,
        endTime: null,
        dayType: 1,
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
  },
  methods: {
    excelOut1() {
      var that = this;
      var url =
        "/manager/user/pc/good_sale_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      if (that.filters.startTime) {
        url = url + "&beginTime=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.inviteUserType) {
        url = url + "&invite_user_type=" + that.filters.invite_user_type;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      url = url + "&noVipName=" + that.noVipName
      top.location.href = url  + "&id=" + that.searchGoodId + "&type=" + that.searchType;
    },
    goDown(){
      this.$refs.dataTable.bodyWrapper.scrollTop =this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop(){
      this.$refs.dataTable.bodyWrapper.scrollTop =0;
    },
    showDetailInfos(row, type) {
      let that = this;
      that.subListVisible = true;
      this.page_size = 10;
      this.page_num = 1;
      this.searchGoodId = row.goodId;
      this.noVipName = row.noVipName
      this.searchType = type;
      this.searchDetail(this.searchGoodId, this.searchType,this.noVipName);
    },
    searchDetail(goodId, type,noVipName) {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        id: goodId,
        type: type,
        noVipName: noVipName,
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      if (that.filters.startTime) {
        para.beginTime = that.filters.startTime.getTime();
      }
      if (that.filters.roleType) {
        para.roleType = that.filters.roleType;
      }
      if (that.filters.endTime) {
        para.endTime = that.filters.endTime.getTime();
      }
      that.detailListLoading = true;
      API.good_sale_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/good_sale_count_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      if (that.filters.title) {
        url = url + "&keyword=" + that.filters.title;
      }
      if (that.filters.startTime) {
        url = url + "&beginTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择时间',
          duration: 2000
        });
        return;
      }
      url = url + "&dayType=" + that.filters.dayType
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      top.location.href = url;
    },
    handleSearch() {

      this.search();
    },
    formatterRoleType(row, column) {
      if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == -0.5) {
        return "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        return "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      }  else if (row.role_type == 4.8) {
        return "经销商";
      }
    },

    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      if (that.filters.startTime) {
        params.beginTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      // params.endTime = params.beginTime
      params.dayType = that.filters.dayType

      that.listLoading = true;
      API.good_sale_count(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i = 0; i < result.result.list.length; i++) {
                //   if (result.result.list[i].pay_time != null) {
                //     result.result.list[i].pay_time = dateFunc.formatDate(
                //       new Date(parseInt(result.result.list[i].pay_time)),
                //       "yyyy-MM-dd hh:mm:ss"
                //     );
                //   }
                // }
              } else {
                result.result.list = [];
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.searchDetail(this.searchGoodId, this.searchType,this.noVipName);
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/saleNumData.vue